import { render, staticRenderFns } from "./VoirNotes.vue?vue&type=template&id=0dd2fba2&scoped=true&"
import script from "./VoirNotes.vue?vue&type=script&lang=js&"
export * from "./VoirNotes.vue?vue&type=script&lang=js&"
import style0 from "./VoirNotes.vue?vue&type=style&index=0&id=0dd2fba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2fba2",
  null
  
)

export default component.exports